import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import emailjs from "emailjs-com";
import "../App.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

import * as incorrectAnimation from "../assets/incorrectAnimation.json";
import * as correctAnimation from "../assets/correctAnimation.json";
import * as coinAdded from "../assets/coinAdded.json";
import * as secondAdded from "../assets/plusSeconds.json";
import * as wallet from "../assets/wallet.json";

import wordsArray from "../assets/words_tg.json";
function GamePage() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const recipientEmail = "Biniam@goodppls.com";
  const handleFeedback = () => {
    const subject = encodeURIComponent("Feedback"); // Optionally, you can set a subject for the email
    const body = encodeURIComponent(
      "Vocaps,\n\nI would like to share the following feedback:\n\n"
    ); // Optionally, you can set a body for the email
    window.location.href = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
  };
  const amharicAlpabet = [
    ["ሀ", "ሁ", "ሂ", "ሃ", "ሄ", "ህ", "ሆ"],
    ["ለ", "ሉ", "ሊ", "ላ", "ሌ", "ል", "ሎ"],
    ["ሐ", "ሑ", "ሒ", "ሓ", "ሔ", "ሕ", "ሖ"],
    ["መ", "ሙ", "ሚ", "ማ", "ሜ", "ም", "ሞ"],
    ["ሠ", "ሡ", "ሢ", "ሣ", "ሤ", "ሥ", "ሦ"],
    ["ረ", "ሩ", "ሪ", "ራ", "ሬ", "ር", "ሮ"],
    ["ሰ", "ሱ", "ሲ", "ሳ", "ሴ", "ስ", "ሶ"],
    ["ሸ", "ሹ", "ሺ", "ሻ", "ሼ", "ሽ", "ሾ"],
    ["ቀ", "ቁ", "ቂ", "ቃ", "ቄ", "ቅ", "ቆ"],
    ["በ", "ቡ", "ቢ", "ባ", "ቤ", "ብ", "ቦ"],
    ["ቨ", "ቩ", "ቪ", "ቫ", "ቬ", "ቭ", "ቮ"],
    ["ተ", "ቱ", "ቲ", "ታ", "ቴ", "ት", "ቶ"],
    ["ቸ", "ቹ", "ቺ", "ቻ", "ቼ", "ች", "ቾ"],
    ["ኀ", "ኁ", "ኂ", "ኃ", "ኄ", "ኅ", "ኆ"],
    ["ነ", "ኑ", "ኒ", "ና", "ኔ", "ን", "ኖ"],
    ["ኘ", "ኙ", "ኚ", "ኛ", "ኜ", "ኝ", "ኞ"],
    ["አ", "ኡ", "ኢ", "ኣ", "ኤ", "እ", "ኦ"],
    ["ከ", "ኩ", "ኪ", "ካ", "ኬ", "ክ", "ኮ"],
    ["ኸ", "ኹ", "ኺ", "ኻ", "ኼ", "ኽ", "ኾ"],
    ["ወ", "ዉ", "ዊ", "ዋ", "ዌ", "ው", "ዎ"],
    ["ዐ", "ዑ", "ዒ", "ዓ", "ዔ", "ዕ", "ዖ"],
    ["ዘ", "ዙ", "ዚ", "ዛ", "ዜ", "ዝ", "ዞ"],
    ["ዠ", "ዡ", "ዢ", "ዣ", "ዤ", "ዥ", "ዦ"],
    ["የ", "ዩ", "ዪ", "ያ", "ዬ", "ይ", "ዮ"],
    ["ደ", "ዱ", "ዲ", "ዳ", "ዴ", "ድ", "ዶ"],
    ["ጀ", "ጁ", "ጂ", "ጃ", "ጄ", "ጅ", "ጆ"],
    ["ገ", "ጉ", "ጊ", "ጋ", "ጌ", "ግ", "ጎ"],
    ["ጠ", "ጡ", "ጢ", "ጣ", "ጤ", "ጥ", "ጦ"],
    ["ጨ", "ጩ", "ጪ", "ጫ", "ጬ", "ጭ", "ጮ"],
    ["ጰ", "ጱ", "ጲ", "ጳ", "ጴ", "ጵ", "ጶ"],
    ["ጸ", "ጹ", "ጺ", "ጻ", "ጼ", "ጽ", "ጾ"],
    ["ፀ", "ፁ", "ፂ", "ፃ", "ፄ", "ፅ", "ፆ"],
    ["ፈ", "ፉ", "ፊ", "ፋ", "ፌ", "ፍ", "ፎ"],
    ["ፐ", "ፑ", "ፒ", "ፓ", "ፔ", "ፕ", "ፖ"],
  ];

  const columnColors = [
    "#000000",
    "#DA300B",
    "#DEB82A",
    "#00B050",
    "#0000FF",
    "#8064A2",
    "#B7B7B7",
  ];
  const [timeLeft, setTimeLeft] = useState(90);
  const commonWordsGroups = [3, 9, 11, 14, 16, 17];
  const [points, setPoints] = useState(500);
  const [draggedItem, setDraggedItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState(false);
  const [showMissing, setShowMissing] = useState(false);
  const [showDefinition, setShowDefinition] = useState(false);
  const [currentDescription, setCurrentDescription] = useState("");
  const [currentHint1, setCurrentHint1] = useState("");
  const [currentHint2, setCurrentHint2] = useState("");
  const [currentHint3, setCurrentHint3] = useState("");
  const [selectedWord, setSelectedWord] = useState("");

  const currentWordObj =
    currentIndex < wordsArray.length ? wordsArray[currentIndex] : null; // Ensure currentWordObj is defined
  const [selectedLevel, setSelectedLevel] = useState("Beginner");
  const [selectedGameType, setSelectedGameType] = useState("FreePlay");
  const [answerDropped, setAnswerDropped] = useState(false);
  const [showCoinAnimation, setShowCoinAnimation] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showWordModal, setShowWordModal] = useState(false);
  const [showHintModal, setShowHintModal] = useState(false);
  const [showGameOverModal, setShowGameOverModal] = useState(false);
  const [showNotEnoughCoinsModal, setShowNotEnoughCoinsModal] = useState(false);
  const [timeIsUp, setTimeIsUp] = useState(false);
  const [email, setEmail] = useState("");
  const [clickedWord, setClickedWord] = useState("");
  const [showAnswer, setShowAnswer] = useState(false);
  const BIN_ID = "66d6c0cdad19ca34f89f4d54";
  const API_KEY =
    "$2a$10$v1S1l2pNRqqSQgWfq9tplOAW9Ocu9/0bONnlI5nsqxavJdscSm8ra";
  const BIN_VERSION = "latest"; // Or specify a version if needed
  const [codes, setCodes] = useState([]);
  const [randomCode, setRandomCode] = useState(null);
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
  const [wrongAnswersCount, setWrongAnswersCount] = useState(0);
  const [visibleGroups, setVisibleGroups] = useState(commonWordsGroups);
  const [hideCharactersTimer, setHideCharactersTimer] = useState(null);
  const [consecutiveCorrect, setConsecutiveCorrect] = useState(0);
  const [showSecondsAnimation, setShowSecondsAnimation] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);
  // Countdown effect
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else {
      if (selectedGameType === "TimedPlay") {
        setShowGameOverModal(true);
        setTimeIsUp(true);
      }
    }
  }, [timeLeft]);

  useEffect(() => {
    if (correctAnswer) {
      setShowCoinAnimation(true);
      setTimeout(() => {
        setShowCoinAnimation(false);
      }, 3000);
    }
  }, [correctAnswer]);

  useEffect(() => {
    shuffleArray(wordsArray);
    // setCurrentHint1(currentWordObj.hint1);
    setShowMissing(true);
    setShowResult(false);
    if (selectedWord !== "") {
      handleCheckWord();
    }
  }, [selectedWord]);

  useEffect(() => {
    const storedLevel = localStorage.getItem("selectedLevel");
    const storedGameType = localStorage.getItem("selectedGameType");
    if (storedLevel) {
      setSelectedLevel(storedLevel);
    }
    if (storedGameType) {
      setSelectedGameType(storedGameType);
    }
  }, []);

  useEffect(() => {
    if (
      selectedGameType === "FreePlay" &&
      showMissing &&
      !showAnswer &&
      !answerDropped
    ) {
      // Clear any existing timer
      if (hideCharactersTimer) {
        clearInterval(hideCharactersTimer);
      }

      // Start new timer to hide characters
      const timer = setInterval(() => {
        setVisibleGroups((prevGroups) => {
          if (prevGroups.length == 2) {
            setShowAnswer(true);
            clearInterval(timer);
            setCurrentHint1(currentWordObj.hint3);
              setWrongAnswersCount((prevCount) => prevCount + 1);
              setTimeout(() => {
                handleNextWord();
              }, 3000);
            return prevGroups;
          }

          // Find the group containing the correct answer
          const correctGroup = commonWordsGroups.find((groupIndex) => {
            return checkWordGroup(currentWordObj.answer_tg, groupIndex);
          });

          // Filter out one random wrong group
          const wrongGroups = prevGroups.filter(
            (group) => group !== correctGroup
          );
          const randomWrongGroupIndex = Math.floor(
            Math.random() * wrongGroups.length
          );

          // Remove the random wrong group
          return prevGroups.filter((group, index) => {
            if (group === correctGroup) return true;
            return wrongGroups.indexOf(group) !== randomWrongGroupIndex;
          });
        });
      }, 3000);

      setHideCharactersTimer(timer);

      return () => {
        if (timer) {
          clearInterval(timer);
        }
      };
    }
  }, [currentIndex, showMissing, showAnswer, answerDropped, selectedGameType]);

  useEffect(() => {
    setVisibleGroups(commonWordsGroups);
  }, [currentIndex]);

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  const toggleShowAnswer = () => {
    setCurrentHint1(currentWordObj.hint3);
    setCurrentHint3(currentWordObj.answer_en);
    setShowAnswer((prevShowAnswer) => !prevShowAnswer);
    setShowDefinition(true);
    if (selectedGameType !== "FreePlay") {
      if (points > 50) {
        setPoints((prevPoints) => {
          const newPoints = prevPoints - 50;
          return newPoints;
        });
      } else {
        navigate("/");
      }
    }
  };
  const handleDragStart = (event, groupIndex) => {
    setDraggedItem(groupIndex);
  };

  const handleDragOver = (event, groupIndex) => {
    setDraggedItem(groupIndex);
    event.preventDefault();
  };

  const onDragOver = (ev) => {
    ev.preventDefault();
  };

  const onDrop = (ev, cat) => {
    handleRowClick(draggedItem);
  };
  const endGame = () => {
    navigate("/");
  };
  const handleCheckWord = () => {
    setShowMissing(false);
    if (selectedWord.toLowerCase() === currentWordObj.answer_tg) {
      setShowResult(true);
      setCorrectAnswer(true);
      setCurrentDescription(currentWordObj.description);
    } else {
      setShowResult(true);
      setCorrectAnswer(false);
    }
  };
  const handleCorretWord = () => {
    setShowCoinAnimation(true);
    setCurrentIndex((prevIndex) => prevIndex + 1);
    setShowResult(false);
    setCorrectAnswer(false);
    setSelectedWord("");
    setShowMissing(true);
    setCurrentDescription("");
    setCurrentHint1("");
    setCurrentHint2("");
    setAnswerDropped(false);
  };
  const handleNextWord = () => {
    setShowDefinition(false);
    setShowAnswer(false);
    setCurrentIndex((prevIndex) => prevIndex + 1);
    setShowResult(false);
    setCorrectAnswer(false);
    setSelectedWord("");
    setShowMissing(true);
    setCurrentDescription("");
    setCurrentHint1("");
    setCurrentHint2("");
    setCurrentHint3("");
    setAnswerDropped(false);
    setShowHintModal(false);
    setShowWordModal(false);
  };

  const handleWordSelect = (word) => {
    setSelectedWord(word);
    setShowMissing(true);
    handleCheckWord();
  };
  const handleAnswer = () => {
    setShowResult(true);
  };
  const handleNoAnswer = () => {
    setShowMissing(false);
    setShowResult(true);
  };
  const handleYesAnswer = () => {};
  const showHint = () => {
    // setCurrentHint1(currentWordObj.hint3);
    // if (points > 25) {
    //   setPoints((prevPoints) => {
    //     const newPoints = prevPoints - 25;
    //     return newPoints;
    //   });
    // }else{
    //   navigate("/");
    // }
    setShowHintModal(true);
    setCurrentHint1(currentWordObj.hint3);
    if (selectedGameType !== "FreePlay") {
      if (points > 25) {
        setPoints((prevPoints) => {
          const newPoints = prevPoints - 25;
          return newPoints;
        });
      } else {
       navigate("/");
      }
    }
  };
  const findWordIndexOnce1 = (groupIndex) => {
    const group = amharicAlpabet[groupIndex];
    for (let i = 0; i < group.length; i++) {
      if (findWordIndex(group[i]) !== -1) {
        return i; // Return the index of the first found character
      }
    }
    return -1; // Return -1 if no character is found
  };
  const findWordIndexOnce = () => {
    let foundIndex = -1;
    let foundAlphabetIndex = 0;
    let found = false;
    amharicAlpabet.forEach((group, groupIndex) => {
      const indexInGroup = group.indexOf(currentWordObj.answer_tg);
      if (indexInGroup !== -1) {
        found = true;
        foundIndex = groupIndex;
      }
    });
    if (found) {
      foundAlphabetIndex = amharicAlpabet[foundIndex].indexOf(
        currentWordObj.answer_tg
      );
    }
    return foundAlphabetIndex;
  };
  const findWordIndex = (word) => {
    let foundIndex = -1;
    let foundAlphabetIndex = 0;
    let found = false;
    amharicAlpabet.forEach((group, groupIndex) => {
      const indexInGroup = group.indexOf(word);
      if (indexInGroup !== -1) {
        found = true;
        foundIndex = groupIndex;
      }
    });
    if (found) {
      foundAlphabetIndex = amharicAlpabet[foundIndex].indexOf(word);
    }
    return foundAlphabetIndex;
  };

  const handleRowClick = (groupIndex) => {
    if (currentWordObj.answer_tg) {
      setShowMissing(false);
      const isInGroup = checkWordGroup(currentWordObj.answer_tg, groupIndex);
      if (isInGroup) {
        handleScreenShot(true);
        setAnswerDropped(true);
        if (selectedGameType !== "FreePlay") {
          setPoints((prevPoints) => {
            const newPoints = prevPoints + 100;
            const emailSentVocap = localStorage.getItem("emailSentVocap");
            if (!emailSentVocap && newPoints > 2500 && prevPoints <= 2500) {
              setShowEmailModal(true);
              localStorage.setItem("emailSentVocap", true);
            }
            return newPoints;
          });

          // Add consecutive correct counter for TimedPlay
          if (selectedGameType === "TimedPlay") {
            setConsecutiveCorrect((prev) => {
              const newCount = prev + 1;
              if (newCount === 3) {
                setTimeLeft((time) => time + 5); // Add 5 seconds
                setShowSecondsAnimation(true); // Show the animation
                setTimeout(() => {
                  setShowSecondsAnimation(false);
                }, 2000); // Hide after 1 second
                return 0; // Reset counter after reaching 3
              }
              return newCount;
            });
          }
        }
        if (selectedGameType === "FreePlay") {
          setCorrectAnswersCount((prevCount) => prevCount + 1);
        }
        handleCorretWord();
        setTimeout(() => {
          setShowCoinAnimation(false);
        }, 3000);
      } else {
        handleScreenShot(false);
        setShowResult(true);
        setCorrectAnswer(false);
        setAnswerDropped(false);
        setCurrentHint1(currentWordObj.hint3);

        if (selectedGameType !== "FreePlay") {
          if (points > 150) {
            setPoints(points - 150);
          } else {
            setShowNotEnoughCoinsModal(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          }
        }
        if (selectedGameType === "FreePlay") {
          // Only show answer and end the round if we're down to 1 or fewer groups
          if (visibleGroups.length <= 2) {
            setShowAnswer(true);
            setWrongAnswersCount((prevCount) => prevCount + 1);
            setTimeout(() => {
              handleNextWord();
            }, 3000);
          } else {
            // If we have more groups, just show the wrong answer feedback briefly
            setTimeout(() => {
              setShowResult(false);
              setShowMissing(true);
            }, 1000);
          }
        }
        // Reset consecutive correct counter on wrong answer
        if (selectedGameType === "TimedPlay") {
          setConsecutiveCorrect(0);
          setTimeout(() => {
            handleNextWord();
          }, 1000);
        }
      }
    } else {
      console.log("No word selected.");
    }
  };

  const handleEmailSubmit = async (e) => {
    if (codes.length === 0) {
      fetchData();
    }

    // Ensure codes is an array
    if (!Array.isArray(codes)) {
      console.error("Codes is not an array:", codes);
      return;
    }

    // Filter codes with status false
    const falseStatusCodes = codes.filter((item) => !item.status);

    if (falseStatusCodes.length === 0) {
      alert("No codes with false status are left.");
      return;
    }

    // Select a random code
    const randomItem =
      falseStatusCodes[Math.floor(Math.random() * falseStatusCodes.length)];
    setRandomCode(randomItem.code);

    // Update the status of the selected code
    const updatedCodes = codes.map((item) =>
      item.code === randomItem.code ? { ...item, status: true } : item
    );

    updateData(updatedCodes);

    e.preventDefault();
    const serviceID = "service_pof0q1i";
    const templateID = "template_b0o4idr";
    const userID = "gXsygUtSGNRXESn60";
    const templateParams = {
      to_email: email,
      message:
        "Your email address has been added to the GP Rewards Daily Raffle list for a chance to win our signature prize. Starting tomorrow, you can <a href='https://www.goodppls.com'>Click here</a> to see if you have been selected as the winner. There is a new winner every day.",
    };
    setShowEmailModal(false);
    try {
      await emailjs.send(serviceID, templateID, templateParams, userID);
      setShowEmailModal(false);
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };
  const checkWordGroup = (word, groupIndex) => {
    return amharicAlpabet[groupIndex].includes(word);
  };
  const handleWordClick = (word) => {
    setClickedWord(word);
    if(word !== currentWordObj.answer_tg){
      setShowWordModal(true);
    }
  };
  const incorrectOptions = {
    loop: true,
    autoplay: true,
    animationData: incorrectAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const correctOptions = {
    loop: true,
    autoplay: true,
    animationData: correctAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const coinAddedOption = {
    loop: true,
    autoplay: true,
    animationData: coinAdded,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const secondAddedOption = {
    loop: true,
    autoplay: true,
    animationData: secondAdded,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const walletOption = {
    loop: true,
    autoplay: true,
    animationData: wallet,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const FullContainer = styled.div`
    overflow-y: scroll;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-width: 10px;
    border-style: solid;
    border-image-slice: 1;
    border-image-source: ${(props) =>
      props.success === null
        ? "linear-gradient(45deg, transparent, transparent)"
        : props.success
        ? "linear-gradient(45deg, #88d988, #65e365)"
        : "linear-gradient(45deg, #ef6565, #ef6565)"};
    padding: 20px;
    animation: ${(props) => (props.success !== null ? gradientShadow : "none")}
      1s infinite;
    transition: border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
  `;
  const gradientShadow = keyframes`
  0% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
  }
  50% {
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.9);
  }
  100% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
  }
`;
  const [isSuccess, setIsSuccess] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleScreenShot = (success) => {
    setIsSuccess(success);
    setIsVisible(true);

    setTimeout(() => {
      setIsSuccess(null);
      setIsVisible(false);
    }, 500);
  };
  const fetchData = () => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            console.log(response);
            // Ensure response.record is an array
            setCodes(
              Array.isArray(response.record.record)
                ? response.record.record
                : []
            );
          } catch (e) {
            console.error("Error parsing JSON:", e);
            setCodes([]); // Clear codes on error
          }
        } else {
          console.error("Error fetching data:", xhr.status, xhr.statusText);
        }
      }
    };
    xhr.open("GET", `https://api.jsonbin.io/v3/b/${BIN_ID}`, true);
    xhr.setRequestHeader("X-Master-Key", API_KEY);
    xhr.send();
  };

  // Function to update data in JSONBin
  const updateData = (updatedCodes) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          fetchData(); // Refresh data
        } else {
          console.error("Error updating data:", xhr.status, xhr.statusText);
        }
      }
    };
    xhr.open("PUT", `https://api.jsonbin.io/v3/b/${BIN_ID}`, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Master-Key", API_KEY);
    xhr.send(JSON.stringify({ record: updatedCodes }));
  };

  // Function to show and update a random code
  const handleShowRandomCode = () => {
    // Fetch data if not already fetched
    if (codes.length === 0) {
      fetchData();
    }

    // Ensure codes is an array
    if (!Array.isArray(codes)) {
      console.error("Codes is not an array:", codes);
      return;
    }

    // Filter codes with status false
    const falseStatusCodes = codes.filter((item) => !item.status);

    if (falseStatusCodes.length === 0) {
      alert("No codes with false status are left.");
      return;
    }

    // Select a random code
    const randomItem =
      falseStatusCodes[Math.floor(Math.random() * falseStatusCodes.length)];
    setRandomCode(randomItem.code);
    // Update the status of the selected code
    const updatedCodes = codes.map((item) =>
      item.code === randomItem.code ? { ...item, status: true } : item
    );

    updateData(updatedCodes);
  };

  return (
    <>
      <FullContainer success={isSuccess} visible={isVisible}>
        <Container>
          <Row>
            <Col xs={3} md={3} className="d-none d-md-block"></Col>
            <Col xs={12} md={6}>
              {currentIndex < wordsArray.length ? (
                <div class="row">
                  <div class="col">
                    <div className="word-container">

                      {selectedGameType === "TimedPlay" ? (
                        <div className="circle-timer">
      <h1 className="timer-text">{timeLeft}</h1>
    </div>
                      ) : (
                        <></>
                      )}

                      {!timeIsUp &&
                      showAnswer &&
                      currentIndex + 1 < wordsArray.length ? (
                        <div className="word-select mt-4">
                          <div className="word">
                            {currentWordObj.en.map((substring, index) => (
                              <div
                                key={index}
                                className={`substring-box  
                          ${substring === currentWordObj.answer_en ? "" : ""}
                          `}
                                style={{
                                  color: columnColors[findWordIndex(substring)],
                                  cursor: "pointer",
                                }}
                                onClick={() => handleWordClick(substring)}
                              >
                                {substring === currentWordObj.answer_en ? (
                                  <button
                                    className="easy-btn"
                                    onDragOver={(e) => onDragOver(e)}
                                    onDrop={(e) => onDrop(e)}
                                    style={{
                                      fontSize:
                                        answerDropped || showAnswer
                                          ? "35px"
                                          : "25px",
                                      color: columnColors[findWordIndexOnce()],
                                    }}
                                  >
                                    {answerDropped || showAnswer
                                      ? currentWordObj.answer_en
                                      : "?"}
                                  </button>
                                ) : (
                                  substring
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div
                        className={`word-select mt-4 ${
                          showMissing ? "hidden" : ""
                        }`}
                      >
                        <div
                          className={`word ${
                            correctAnswer ? "correctAnimation" : ""
                          }`}
                        >
                          {currentWordObj.tg.map((substring, index) => (
                            <div
                              key={index}
                              className={`substring-box  
                            ${substring === currentWordObj.answer_tg ? "" : ""}
                             `}
                              style={{
                                color: columnColors[findWordIndex(substring)],
                                cursor: "pointer",
                              }}
                              onClick={() => handleWordClick(substring)}
                            >
                              {currentWordObj.hide ? (
                                <>
                                  {substring === currentWordObj.answer_tg &&
                                  index ===
                                    parseInt(currentWordObj.hide) - 1 ? (
                                    <button
                                      className="easy-btn droppable"
                                      onDragOver={(e) => onDragOver(e)}
                                      onDrop={(e) => onDrop(e)}
                                      style={{
                                        fontSize:
                                          answerDropped || showAnswer
                                            ? "35px"
                                            : "25px",
                                        color:
                                          columnColors[findWordIndexOnce()],
                                      }}
                                    >
                                      {answerDropped || showAnswer
                                        ? currentWordObj.answer_tg
                                        : "?"}
                                    </button>
                                  ) : (
                                    substring
                                  )}
                                </>
                              ) : (
                                <>
                                  {substring === currentWordObj.answer_tg ? (
                                    <button
                                      className="easy-btn droppable"
                                      onDragOver={(e) => onDragOver(e)}
                                      onDrop={(e) => onDrop(e)}
                                      style={{
                                        fontSize:
                                          answerDropped || showAnswer
                                            ? "35px"
                                            : "25px",
                                        color:
                                          columnColors[findWordIndexOnce()],
                                      }}
                                    >
                                      {answerDropped || showAnswer
                                        ? currentWordObj.answer_tg
                                        : "?"}
                                    </button>
                                  ) : (
                                    substring
                                  )}
                                </>
                              )}
                            </div>
                          ))}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      {showResult && (
                        <div className="result-container make-center">
                          <p
                            className={`text-center result ${
                              correctAnswer ? "correct" : "incorrect"
                            }`}
                          >
                            <h2 style={{ marginLeft: "20px" }}>
                              {correctAnswer ? (
                                <Lottie
                                  options={correctOptions}
                                  height={100}
                                  width={300}
                                  isClickToPauseDisabled={true}
                                />
                              ) : (
                                <>
                                  {!showAnswer ? (
                                    <>
                                      {selectedGameType === "FreePlay" ? (
                                        <>
                                          {/* <Lottie
                                          options={incorrectOptions}
                                          height={70}
                                          width={150}
                                          isClickToPauseDisabled={true}
                                        /> */}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="hint make-center">
                                      <h5>Definition: {currentHint1}</h5>
                                    </p>
                                  )}
                                </>
                              )}

                              {/* {selectedLevel === "Beginner" ? (
                              <div>
                                  <button
                                    className="btn btn2 mb-4"
                                    onClick={handleNextWord}
                                  >
                                    Next Word
                                  </button>  ): ('')
                              }    */}
                            </h2>
                          </p>
                          {/* {correctAnswer && (
                            <div>
                              <h2>{currentDescription}</h2>
                              {currentIndex + 1 < wordsArray.length ? (
                                <button
                                  className="btn btn2 mb-4"
                                  onClick={handleNextWord}
                                >
                                  Next Word
                                </button>
                              ) : (
                                <>
                                  <button
                                    className="btn btn2 mb-4"
                                    onClick={endGame}
                                  >
                                    End Game
                                  </button>
                                </>
                              )}
                            </div>
                          )} */}
                        </div>
                      )}
                      {showMissing &&
                        selectedLevel === "Beginner" &&
                        selectedGameType === "FreePlay" && (
                          <div className="">
                            {!showAnswer ? (
                              <button
                                class="btn me-2 mb-2"
                                style={{ marginLeft: "35px" }}
                                onClick={() => showHint()}
                              >
                                Hint
                              </button>
                            ) : null}
                            {!showAnswer && currentHint2 !== "" ? (
                              <p className="hint">
                                <h5>{currentHint2}</h5>
                              </p>
                            ) : null}
                            {showAnswer ? (
                              <p className="hint make-center">
                                <h5>Definition: {currentHint1}</h5>
                              </p>
                            ) : (
                              <></>
                            )}
                            {!showDefinition && !showAnswer ? (
                              <div
                                className="buttons-container"
                                style={{
                                  marginLeft: "35px",
                                  marginTop: "20px",
                                }}
                              >
                                {visibleGroups.map((groupIndex) => {
                                  const foundIndex = findWordIndexOnce();
                                  const foundCharacter =
                                    amharicAlpabet[groupIndex][foundIndex];
                                  return (
                                    <div
                                      key={groupIndex}
                                      className=""
                                      draggable
                                      onDragStart={(e) =>
                                        handleDragStart(e, groupIndex)
                                      }
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        handleDragOver(e, groupIndex);
                                      }}
                                      onClick={() => handleRowClick(groupIndex)}
                                    >
                                      <button className="btn-group mb-2 me-2">
                                        <span
                                          className=""
                                          style={{
                                            color: columnColors[foundIndex],
                                          }}
                                        >
                                          {foundCharacter}
                                        </span>
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <></>
                            )}
{/* 
                            <div>
                              {currentIndex === wordsArray.length - 1 &&
                              showAnswer ? (
                                <>
                                 
                                </>
                              ) : (
                                <></>
                              )}
                            </div> */}
                          </div>
                        )}
                      {showMissing &&
                        selectedLevel === "Beginner" &&
                        selectedGameType === "TimedPlay" && (
                          <div className="">
                            {/* {!timeIsUp && !showAnswer ? (
                              <button
                                class="btn me-2 mb-2"
                                style={{ marginLeft: "35px" }}
                                onClick={() => showHint()}
                              >
                                Hint
                              </button>
                            ) : null}
                            {!timeIsUp && !showAnswer && currentHint2 !== "" ? (
                              <p className="hint">
                                <h5>{currentHint2}</h5>
                              </p>
                            ) : null}
                            {!timeIsUp && showAnswer ? (
                              <p className="hint make-center">
                                <h5>{currentHint1}</h5>
                              </p>
                            ) : (
                              <></>
                            )} */}
                            {!timeIsUp && !showDefinition ? (
                              <div
                                className="buttons-container"
                                style={{
                                  marginLeft: "35px",
                                  marginTop: "20px",
                                }}
                              >
                                {commonWordsGroups.map((groupIndex) => {
                                  const foundIndex = findWordIndexOnce();
                                  const foundCharacter =
                                    amharicAlpabet[groupIndex][foundIndex];
                                  return (
                                    <div
                                      key={groupIndex}
                                      className=""
                                      draggable
                                      onDragStart={(e) =>
                                        handleDragStart(e, groupIndex)
                                      }
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        handleDragOver(e, groupIndex);
                                      }}
                                      onClick={() => handleRowClick(groupIndex)}
                                    >
                                      <button className="btn-group mb-2 me-2">
                                        <span
                                          className=""
                                          style={{
                                            color: columnColors[foundIndex],
                                          }}
                                        >
                                          {foundCharacter}
                                        </span>
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <></>
                            )}

                            <div>
                              {timeIsUp ||
                              (currentIndex === wordsArray.length - 1 &&
                                showAnswer) ? (
                                <>
                                  {/* <button
                                    className="btn btn2 mb-4"
                                    onClick={endGame}
                                  >
                                    End Game
                                  </button> */}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                      {showMissing && selectedLevel === "Intermediate" && (
                        <div className="">
                          {amharicAlpabet.map((group, groupIndex) => (
                            <div key={groupIndex} className="row-container">
                              <button
                                className="btn-group mb-2"
                                onClick={() => handleRowClick(groupIndex)}
                              >
                                {group.map((character, index) => (
                                  <span
                                    key={index}
                                    className="character "
                                    style={{ color: columnColors[index] }}
                                  >
                                    {character}
                                  </span>
                                ))}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                      {showMissing && selectedLevel === "Advanced" && (
                        <div className="">
                          {amharicAlpabet.map((group, groupIndex) => (
                            <div key={groupIndex} className="">
                              {group.map((character, index) => (
                                <button
                                  key={index}
                                  className={`btn me-4 mb-2 pe-4 ${
                                    selectedWord === character ? "selected" : ""
                                  }`}
                                  onClick={() => handleWordSelect(character)}
                                  style={{ color: columnColors[index] }}
                                >
                                  {`${character}`}
                                </button>
                              ))}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <p>Game Over.</p>
                  {selectedGameType === "FreePlay" && (
                    <div className="report-container">
                      <h3>Game Report</h3>
                      <p>Correct Answers: {correctAnswersCount}</p>
                      <p>Wrong Answers: {wrongAnswersCount}</p>
                    </div>
                  )}
                </>
              )}
            </Col>
            <Col xs={12} md={3}>
              {/* <Row>
                {!showCoinAnimation && selectedGameType !== "FreePlay" && (
                  <button className="easy-btn">
                    <Lottie
                      options={walletOption}
                      height={100}
                      style={{ "margin-left": "0px" }}
                      isClickToPauseDisabled={true}
                    />
                    {points} Coins
                  </button>
                )}

                {showCoinAnimation && selectedGameType !== "FreePlay" && (
                  <button className="easy-btn">
                    <Lottie
                      options={coinAddedOption}
                      height={100}
                      width={70}
                      isClickToPauseDisabled={true}
                    />
                    {points} Coins
                  </button>
                )}
              </Row> */}
              <Row className="d-flex justify-content-center align-items-center">
      <button className="btn btn2 floating-button" onClick={endGame}>
        End Game
      </button>
    </Row>
            </Col>

            <Modal
              show={showWordModal && !showAnswer}
              onHide={() => setShowWordModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <h1 className="text-center">
                  {currentWordObj !== null &&
                    clickedWord !== currentWordObj.answer_tg &&
                    currentWordObj.en[currentWordObj.tg.indexOf(clickedWord)]}
                </h1>
              </Modal.Body>
            </Modal>
            <Modal
              show={showHintModal && !showAnswer}
              onHide={() => setShowHintModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>Definition: {currentHint1}</h5>
                </p>
              </Modal.Body>
            </Modal>
            <Modal
              // show={isDisabled}
              show={showGameOverModal}
              onHide={() => setShowGameOverModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>You scored {points} points.</h5>
                </p>
              </Modal.Body>
            </Modal>
            <Modal
              show={showNotEnoughCoinsModal}
              onHide={() => setShowNotEnoughCoinsModal(false)}
              className="small-modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p className="hint make-center">
                  <h5>Practice more and try again.</h5>
                </p>
              </Modal.Body>
            </Modal>
          </Row>
        </Container>
      </FullContainer>
      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Congratulations you have accumulated 2500 coins!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEmailSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Type email address here to be entered into our raffle"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="btn btn2 mb-4">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {selectedGameType === "TimedPlay" && showSecondsAnimation && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
          }}
        >
          <Lottie
            options={secondAddedOption}
            height={100}
            width={70}
            isClickToPauseDisabled={true}
          />
        </div>
      )}
    </>
  );
}

export default GamePage;
